
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation, Scrollbar, A11y, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { Link } from 'react-router-dom';

function BannerEight() {
    const [banners, setBanners] = useState([]);

    useEffect(() => {
        
        // Fetch banners from API
        fetch(`${process.env.REACT_APP_API_URL}/api/banners`)
            .then(res => res.json())
            .then(data => setBanners(data))
            .catch(err => console.error('Error fetching banners:', err));
    }, []);


    return (
        <div>
            {/* rts banner area start */}
            <div className="rts-banner-area-two eight" id='banner' style={{ position: 'relative' }}>
                <div className="swiper mySwiperh3_banner" style={{ position: 'relative' }}>
                    <Swiper
                        modules={[Navigation, EffectFade, Scrollbar, A11y, Autoplay]}
                        className="swiper mySwiperh3_banner"
                        speed={1000}
                        slidesPerView={1}
                        spaceBetween={0}
                        loop={true}
                        autoplay={{ delay: 8000 }}
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }}
                        touchEventsTarget="container"
                        allowTouchMove={true}
                        simulateTouch={true}
                        noSwiping={false}
                        noSwipingClass="swiper-no-swiping"
                        breakpoints={{
                            1200: { slidesPerView: 1 },
                            900: { slidesPerView: 1 },
                            768: { slidesPerView: 1 },
                            580: { slidesPerView: 1 },
                            450: { slidesPerView: 1 },
                            0: { slidesPerView: 1 },
                        }}
                    >
                        {banners?.data?.map((banner, index) => (
                            <SwiperSlide key={index} style={{ position: 'relative' }}>
                                <div
                                    className={`bg_banner-three bg_image rts-section-gap eight`}
                                    style={{
                                        backgroundImage: `url(${process.env.REACT_APP_API_URL}/${banner.image})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        width:'100vw',
                                        height:'800px',
                                        position: 'relative',
                                        display: 'flex',
                                        alignItems: 'center',
                                        zIndex: 1
                                    }}
                                >
                                    <div className="container" style={{ position: 'relative', zIndex: 10, width: '100%' }}>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="banner-three-inner" style={{ position: 'relative', zIndex: 11 }}>
                                                    <span className="subtitle-banner">{banner.tagline}</span>
                                                    <h1 className="title cd-headline clip is-full-width">
                                                        {banner.name}
                                                    </h1>
                                                    {/* <p className="disc">{banner.content}</p> */}
                                                    <div 
                                                        className="button-group swiper-no-swiping"
                                                        style={{
                                                            position: 'relative',
                                                            zIndex: 100,
                                                            pointerEvents: 'auto',
                                                            isolation: 'isolate'
                                                        }}
                                                        onTouchStart={(e) => e.stopPropagation()}
                                                        onTouchEnd={(e) => e.stopPropagation()}
                                                        onTouchMove={(e) => e.stopPropagation()}
                                                    >
                                                        <Link
                                                            to={'/about-us'}
                                                            className="rts-btn btn-primary-2 swiper-no-swiping"
                                                            style={{
                                                                position: 'relative',
                                                                zIndex: 101,
                                                                pointerEvents: 'auto',
                                                                cursor: 'pointer',
                                                                touchAction: 'auto',
                                                                isolation: 'isolate',
                                                                display: 'inline-block',
                                                                textDecoration: 'none'
                                                            }}
                                                            onTouchStart={(e) => e.stopPropagation()}
                                                            onTouchEnd={(e) => e.stopPropagation()}
                                                        >
                                                            About Us
                                                        </Link>
                                                        <Link
                                                            to={'/contactus'}
                                                            className="rts-btn btn-primary-2 transparent swiper-no-swiping"
                                                            style={{
                                                                position: 'relative',
                                                                zIndex: 101,
                                                                pointerEvents: 'auto',
                                                                cursor: 'pointer',
                                                                touchAction: 'auto',
                                                                isolation: 'isolate',
                                                                display: 'inline-block',
                                                                textDecoration: 'none'
                                                            }}
                                                            onTouchStart={(e) => e.stopPropagation()}
                                                            onTouchEnd={(e) => e.stopPropagation()}
                                                        >
                                                            Contact Us
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                {/* <div className="swiper-navigation">
                    <span className="swiper-button-prev" />
                    <span className="swiper-button-next" />
                </div> */}
            </div>
            {/* rts banner area end */}
            <style>{`
                /* Responsive banner height */
                .rts-banner-area-two.eight .bg_banner-three {
                    min-height: 600px;
                }
                
                @media (max-width: 991px) {
                    .rts-banner-area-two.eight .bg_banner-three {
                        height: 600px !important;
                        min-height: 500px;
                    }
                }
                
                @media (max-width: 767px) {
                    .rts-banner-area-two.eight .bg_banner-three {
                        height: 500px !important;
                        min-height: 450px;
                    }
                    
                    .rts-banner-area-two.eight .banner-three-inner {
                        padding: 20px 0;
                    }
                    
                    .rts-banner-area-two.eight .banner-three-inner h1 {
                        font-size: 28px !important;
                    }
                    
                    .rts-banner-area-two.eight .button-group {
                        flex-direction: row;
                        gap: 12px;
                    }
                    
                    .rts-banner-area-two.eight .button-group .rts-btn {
                        width: 100%;
                        text-align: center;
                    }
                }
                
                @media (max-width: 480px) {
                    .rts-banner-area-two.eight .bg_banner-three {
                        height: 450px !important;
                        min-height: 400px;
                    }
                    
                    .rts-banner-area-two.eight .banner-three-inner h1 {
                        font-size: 24px !important;
                    }
                    
                    .rts-banner-area-two.eight .subtitle-banner {
                        font-size: 12px !important;
                    }
                }
                
                /* Ensure buttons are always clickable - Override any overlays */
                .rts-banner-area-two.eight .swiper-wrapper::before,
                .rts-banner-area-two.eight .swiper-wrapper::after,
                .rts-banner-area-two.eight .swiper-slide::before,
                .rts-banner-area-two.eight .swiper-slide::after,
                .rts-banner-area-two.eight .bg_banner-three::before,
                .rts-banner-area-two.eight .bg_banner-three::after {
                    pointer-events: none !important;
                    z-index: 0 !important;
                }
                
                /* Swiper no-swiping class - prevent Swiper from handling touches */
                .rts-banner-area-two.eight .swiper-no-swiping {
                    touch-action: auto !important;
                    -webkit-touch-callout: default !important;
                }
                
                .rts-banner-area-two.eight .button-group {
                    position: relative !important;
                    z-index: 9999 !important;
                    pointer-events: auto !important;
                    -webkit-touch-callout: none;
                    -webkit-user-select: none;
                    user-select: none;
                    isolation: isolate !important;
                }
                
                .rts-banner-area-two.eight .button-group.swiper-no-swiping {
                    touch-action: auto !important;
                }
                
                .rts-banner-area-two.eight .button-group .rts-btn {
                    position: relative !important;
                    z-index: 10000 !important;
                    pointer-events: auto !important;
                    touch-action: manipulation !important;
                    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1) !important;
                    display: inline-block !important;
                    -webkit-touch-callout: none !important;
                    -webkit-user-select: none !important;
                    user-select: none !important;
                    isolation: isolate !important;
                }
                
                .rts-banner-area-two.eight .button-group .rts-btn.swiper-no-swiping {
                    touch-action: auto !important;
                    pointer-events: auto !important;
                }
                
                .rts-banner-area-two.eight .swiper-slide {
                    pointer-events: auto;
                }
                
                .rts-banner-area-two.eight .swiper-slide > div {
                    pointer-events: auto;
                }
                
                .rts-banner-area-two.eight .banner-three-inner {
                    pointer-events: auto !important;
                    z-index: 100 !important;
                    position: relative !important;
                }
                
                .rts-banner-area-two.eight .container {
                    pointer-events: none !important;
                }
                
                .rts-banner-area-two.eight .container .row,
                .rts-banner-area-two.eight .container .col-12 {
                    pointer-events: none !important;
                }
                
                .rts-banner-area-two.eight .banner-three-inner,
                .rts-banner-area-two.eight .banner-three-inner * {
                    pointer-events: auto !important;
                }
                
                /* Prevent Swiper from capturing touch on buttons */
                .rts-banner-area-two.eight .swiper-wrapper {
                    touch-action: pan-y;
                }
                
                .rts-banner-area-two.eight .button-group * {
                    touch-action: manipulation !important;
                }
                
                /* Ensure Swiper doesn't create overlay */
                .rts-banner-area-two.eight .swiper {
                    overflow: visible !important;
                }
                
                .rts-banner-area-two.eight .swiper-wrapper {
                    pointer-events: auto;
                }
                
                @media (max-width: 767px) {
                    .rts-banner-area-two.eight .button-group .rts-btn {
                        min-height: 44px !important;
                        padding: 12px 24px !important;
                        font-size: 16px !important;
                    }
                }
            `}</style>
        </div>
    );
}

export default BannerEight;
